import { DataStore } from 'aws-amplify';
import { WorkflowStatus } from '../models';
import { captureError } from '../common/sentry';

export interface WorkflowStatusProps {
  id: string;
  workflowStatusId: string;
  name: string;
}

export interface WorkflowStatusDataProps {
  create: (data: WorkflowStatusProps) => Promise<WorkflowStatusProps | undefined>;
  getArray: () => Promise<WorkflowStatusProps[] | undefined>;
}

export const workflowStatusData = () => {
  async function create(data: WorkflowStatusProps): Promise<WorkflowStatusProps | undefined> {
    try {
      const created = await DataStore.save(
        new WorkflowStatus({
          id: data.id,
          workflowStatusId: data.workflowStatusId,
          name: data.name
        })
      );

      if (created) {
        return convertToProps(created);
      }

      return undefined;
    } catch (error) {
      console.error('Error creating WorkflowStatus:', error);
      captureError(error, `workflowStatus-create:${data.id}`);
      throw error;
    }
  }

  async function getArray(): Promise<WorkflowStatusProps[] | undefined> {
    const results = await DataStore.query(WorkflowStatus);

    if (results) {
      return results.map((r) => convertToProps(r));
    }

    return undefined;
  }

  function convertToProps(data: WorkflowStatus) {
    const workflowStatusProps: WorkflowStatusProps = {
      id: data.id,
      workflowStatusId: data.workflowStatusId,
      name: data.name
    };
    return workflowStatusProps;
  }

  const returned: WorkflowStatusDataProps = {
    create,
    getArray
  };

  return returned;
};
